import Slider from 'react-slick';

import { BaseLayout } from '../../layouts/BaseLayout';
import { CategoryMenu } from '../../components/CategoryMenu';
import { ProductList } from '../../components/ProductList';

export const Home = () => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <BaseLayout>
      <Slider {...settings}>
        <img alt="Banner name" src="/assets/images/banner.png"/>
        <img alt="Banner name" src="/assets/images/banner2.png"/>
      </Slider>

      <CategoryMenu />

      <ProductList />
    </BaseLayout>
  );
};
